<script>
    export let title;

    $: cleanTitle = title
        ? title.replace('básico', '').replace('+', '').trim()
        : '';

    $: displayTitle = cleanTitle.replace('izzi', '<strong>izzi</strong>');
</script>

<div class="plan-card__service plan-card__service--tv">
    <svg class="plan-card__icon">
        <use xlink:href="/assets/img/icons/symbol-defs.svg#icon-tv"></use>
    </svg>
    <p class="plan-card__text">
        {@html displayTitle}
    </p>
</div>
